import TextInput from "components/form/input/TextInput";
import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields";
import CM from "..";

export function ParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={CM.field + tipoIndicadorField}
            tabFields={
                <>
                    <ParamFormRow label="Metros Lineares">
                        <TextInput name="metrosLineares" label="Valor (Metros)"  type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="Metros Avaliados">
                        <TextInput name="metrosAvaliados" label="Valor (Metros)"  type="number" />
                    </ParamFormRow>
                </>
            }
        />
    );
}
